import { render, staticRenderFns } from "./ManagerCloseTill.template.vue?vue&type=template&id=48086013&scoped=true&"
var script = {}
import style0 from "./ManagerCloseTill.template.vue?vue&type=style&index=0&id=48086013&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48086013",
  null
  
)

export default component.exports